import { z } from "zod"

export const ScheduleCallbackConfigSchema = z.object({
  enabled: z.boolean().optional(),
  voice_agent_id: z.string().uuid().nullable().optional(),
  caller_phone_number: z.string().regex(/^\+[1-9]\d{7,14}$/).nullable().optional(),
  respect_working_hours: z.boolean().optional(),
})

export type ScheduleCallbackConfig = z.infer<typeof ScheduleCallbackConfigSchema>

export function normalizeScheduleCallbackConfig(value: unknown): ScheduleCallbackConfig | null {
  const result = ScheduleCallbackConfigSchema.safeParse(value)
  return result.success ? result.data : null
}

export function isScheduleCallbackConfigured(
  value: ScheduleCallbackConfig | null | undefined,
): value is ScheduleCallbackConfig & { voice_agent_id: string; caller_phone_number: string } {
  return Boolean(value?.voice_agent_id && value.caller_phone_number)
}
